import { httpPost } from '../services'

const AuthApi = {
	login(data) {
		return httpPost('/adminLogin', data)
	}
}

export default AuthApi
